module.exports = __webpack_public_path__ + "img/ft2502.e8d15fe2.jpg";